<template>
  <div :class="{'large': large}">
    <div style="white-space: nowrap">
        <span role="button" @click="isToggled=!isToggled">
          {{ label }}
          <i class="bi" :class="{'bi-toggle-on': isToggled, 'bi-toggle-off': !isToggled}"></i>
        </span>
    </div>
    <transition mode="out-in">
      <div v-if="isToggled">
        <slot />
      </div>
    </transition>
  </div>
</template>
<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue'
const props = defineProps({
  toggled: {type: Boolean, default: false},
  label: {type: String, required: true},
  large: {type: Boolean, default: false},
})
const emits = defineEmits(['update:toggled'])
const isToggled = ref(props.toggled)
watch(isToggled, (v) => {
  emits('update:toggled', v)
})
watch(() => props.toggled, (v) => {
  isToggled.value = v
})
</script>

<style scoped>
.large {transform: scale(150%); transform-origin: left center;}
</style>
